module.exports = __webpack_public_path__ + "0c53800efbfc11b609aed3c13eed7a6e.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/farbtastic/marker.png
// module id = 211
// module chunks = 0